// extracted by mini-css-extract-plugin
export default {"root":"dropdown_root__AeBXC"};